module.exports = __webpack_public_path__ + "img/history_customer.e3af0348.png";